import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { Component } from 'react'
import Button from 'react-bootstrap/Button'
import Overlay from 'react-bootstrap/Overlay'
import Tooltip from 'react-bootstrap/Tooltip'
import axios from 'axios'
import ClipLoader from 'react-spinners/ClipLoader'
import NavContainer from '../NavContainer'
import ClozeContent, { getNextStatement, generateAnswer } from './ClozeContent'
import Reader from './Reader'
import Test from './Test'
import ClozeImage from '../image/ClozeImage'
import styles from './BidirectionalTest.css'

class BidirectionalTest extends Component {
  constructor(props) {
    super(props)

    this.state = {
      current: -1,
      forward: true,
      image: null,
      finished: false,
      pages: [],
      selectedRow: null,
      selectedBegin: null,
      selectedEnd: null,
      reader: true,
      answers: [],
      activities: [],
      imageLoading: false,
      imageFocused: false,
      imagePreloading: true,
      imagePreloadError: false,
      canvasHint: 0,
      restoreHint: 0,
      lastActivities: null
    }
    this.currentSentenceRef = React.createRef()
    this.canvasRef = React.createRef()
    this.imageRef = React.createRef()
    this.restoreRef = React.createRef()

    this.onKeyDown = this.onKeyDown.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkAndNotifyActivitiesAdded(prevState);
    if (
      this.props.autoStart &&
      !this.isReadyToStart(prevProps, prevState) &&
      this.state.current < 0 &&
      this.isReadyToStart()
    ) {
      setTimeout(() => this.start(), 0)
    }
    if (!this.state.image || !this.props.hint || !this.props.hint.next) {
      return
    }
    if (this.performHint('canvas')) {
      return
    }
    if (this.state.imageFocused && this.performHint('restore')) {
    }
  }

  componentDidMount() {
    if (
      this.props.autoStart &&
      this.state.current < 0 &&
      this.isReadyToStart()
    ) {
      setTimeout(() => this.start(), 0)
    }

    window.addEventListener('keydown', this.onKeyDown)
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKeyDown)
  }

  performHint(target) {
    if (this.props.hint === undefined) {
      return false
    }
    if (this.props.hint[target]) {
      // Already performed
      return false
    }
    const propName = `${target}Hint`
    const otherPropNames = Object.keys(this.state).filter(
      (name) => name.endsWith('Hint') && name !== propName
    )
    if (
      otherPropNames.some(
        (name) => this.state[name] !== 0 && this.state[name] !== 3
      )
    ) {
      return false
    }
    if (this.state[propName] !== 0) {
      return false
    }
    setTimeout(() => {
      const s = {}
      s[propName] = 1
      this.setState(s, () => {
        setTimeout(() => {
          const s2 = {}
          s2[propName] = 2
          this.setState(s2)
        }, 500)
      })
    }, 10)
    return true
  }

  hideHint(target) {
    const s = {}
    s[`${target}Hint`] = 3
    this.setState(s)

    if (!this.props.onHintPerform) {
      return
    }
    this.props.onHintPerform(target)
  }

  isAnswered(state, rowIndex, beginIndex, endIndex) {
    const { ignored } = this.props
    if (ignored) {
      if (
        ignored.beginRowIndex !== undefined &&
        ignored.beginRowIndex !== null &&
        rowIndex < ignored.beginRowIndex
      ) {
        return true
      }
      if (
        ignored.endRowIndex !== undefined &&
        ignored.endRowIndex !== null &&
        rowIndex >= ignored.endRowIndex
      ) {
        return true
      }
    }
    return (state.answers || []).some(
      (a) =>
        a.rowIndex === rowIndex &&
        a.beginIndex === beginIndex &&
        (endIndex === undefined || a.endIndex === endIndex)
    )
  }

  updateCompleted(state) {
    state.completed = state.pages.every(
      (page) =>
        page.bounds.length === 0 ||
        page.bounds.every((b) =>
          this.isAnswered(state, b.rowIndex, b.beginIndex)
        )
    )
    state.pageCompleted = state.pages[state.currentPage].bounds.every((b) =>
      this.isAnswered(state, b.rowIndex, b.beginIndex)
    )
  }

  updateImage(state) {
    state.image = state.pages[state.currentPage].image
      ? state.pages[state.currentPage].pageId
      : null
    state.nextImage =
      state.currentPage + 1 < state.pages.length &&
      state.pages[state.currentPage + 1].image
        ? state.pages[state.currentPage + 1].pageId
        : null
    if (state.imageLoading === false && state.image !== null) {
      state.imageLoading = true
    }
  }

  start() {
    const state = this.copyState()
    const { index, pages, pageIndex } = this.nextPage()
    state.current = index
    state.pages = pages
    state.currentPage = pageIndex
    this.updateImage(state)
    state.selectedRow = null
    state.selectedBegin = null
    state.selectedEnd = null
    state.finished = false
    state.answers = (this.props.answers || []).map((a) => Object.assign({}, a))
    state.activities = (this.props.activities || []).map((a) =>
      Object.assign({}, a)
    )
    this.updateCompleted(state)

    this.setState(state, () => {
      if (this.props.onStart) {
        this.props.onStart()
      }
      if (this.props.selected) {
        this.showStatement(
          this.props.selected.rowIndex,
          this.props.selected.beginIndex
        )
      } else {
        const target = this.state.pages[this.state.currentPage].bounds
        this.showStatement(
          target.length > 0 ? target[0].rowIndex : null,
          target.length > 0 ? target[0].beginIndex : null
        )
      }
    })
  }

  nextClicked(forward, activities) {
    console.log('Transition', forward, activities)
    const state = this.copyState()
    state.activities.push({
      time: Date.now(),
      rowIndex: state.selectedRow,
      beginIndex: state.selectedBegin,
      endIndex: state.selectedEnd,
      activities
    })
    this.setState(state, () => {
      const { rowIndex, beginIndex } = getNextStatement(
        this.state,
        this.state.selectedRow,
        this.state.selectedBegin,
        forward
      )
      this.showStatement(rowIndex, beginIndex)
    })
  }

  toNextPage() {
    if (!(this.state.pageCompleted && this.state.hasNextPage)) {
      return
    }
    this.toPage(this.state.currentPage + 1, ['nextpage'])
  }

  toPreviousPage() {
    if (!this.state.hasPreviousPage) {
      return
    }
    this.toPage(this.state.currentPage - 1, ['previouspage'])
  }

  toFirstPage() {
    if (!this.state.hasPreviousPage) {
      return
    }
    this.toPage(0, ['firstpage'])
  }

  toLastPage() {
    if (!(this.state.pageCompleted && this.state.hasNextPage)) {
      return
    }
    const pageOffset = this.state.currentPage + 1
    const pageNumbers = Array.from(
      Array(parseInt(this.state.pages.length - pageOffset)).keys()
    )
      .map((pageNumber) => pageNumber + pageOffset)
      .filter(
        (pageNumber) =>
          this.state.pages[pageNumber - 1] &&
          this.state.pages[pageNumber - 1].bounds &&
          this.isPageAlreadyAnswered(this.state, pageNumber - 1)
      )
    if (pageNumbers.length === 0) {
      console.warn('No next pages')
      return
    }
    this.toPage(pageNumbers[pageNumbers.length - 1], ['lastpage'])
  }

  toPage(pageNumber, action, callback) {
    const state = this.copyState()
    state.activities.push({
      time: Date.now(),
      rowIndex: state.selectedRow,
      beginIndex: state.selectedBegin,
      endIndex: state.selectedEnd,
      activities: (this.state.lastActivities || []).concat([
        {
          time: Date.now(),
          action
        }
      ])
    })
    state.imageFocused = false
    state.lastActivities = null
    this.setState(state, () => {
      const bound = this.state.pages[pageNumber].bounds[0]
      this.showStatement(bound.rowIndex, bound.beginIndex, () => {
        if (!callback) {
          return
        }
        callback()
      })
    })
  }

  nextPageClicked(forward, activities) {
    const state = this.copyState()
    state.activities.push({
      time: Date.now(),
      rowIndex: state.selectedRow,
      beginIndex: state.selectedBegin,
      endIndex: state.selectedEnd,
      activities
    })
    state.imageFocused = false
    this.setState(state, () => {
      const pageOffset = forward ? 1 : -1
      this.nextPageTransition(pageOffset)
    })
  }

  nextPageTransition(pageOffset, callback) {
    const bound = this.state.pages[this.state.currentPage + pageOffset]
      .bounds[0]
    this.showStatement(bound.rowIndex, bound.beginIndex, () => {
      if (!callback) {
        return
      }
      callback()
    })
  }

  finish(activities) {
    console.log('Exit', activities)
    const state = this.copyState()
    state.activities.push({
      time: Date.now(),
      rowIndex: state.selectedRow,
      beginIndex: state.selectedBegin,
      endIndex: state.selectedEnd,
      activities
    })
    state.finished = true
    this.setState(state, () => {
      if (this.props.onFinish) {
        this.props.onFinish(this.state.answers, this.state.activities)
      }
    })
  }

  getContext(state) {
    return {
      selected: {
        rowIndex: state.selectedRow,
        beginIndex: state.selectedBegin
      },
      activities: state.activities,
      answers: state.answers
    }
  }

  getProgress(state) {
    let progress = []
    const pageProgress = []
    ;(state.pages || []).forEach((page) => {
      const local = []
      ;(page.bounds || []).forEach((bound) => {
        const reader = this.props.data.rows[bound.rowIndex]
          .slice(bound.beginIndex, bound.endIndex)
          .every((cell) => cell.split('|').length <= 1)
        const answered = this.isAnswered(
          state,
          bound.rowIndex,
          bound.beginIndex
        )
        const current =
          bound.rowIndex === state.selectedRow &&
          bound.beginIndex === state.selectedBegin
        local.push({ reader, answered, current })
      })
      if (local.length === 0) {
        pageProgress.push({ bounds: 0, rate: null })
        return
      }
      pageProgress.push({
        bounds: (page.bounds || []).length,
        rate: local.filter((p) => p.answered).length / local.length
      })
      progress = progress.concat(local)
    })
    const current = (progress
      .map((p, index) => [p.current, index])
      .filter((p) => p[0])
      .map((p) => p[1]) || [-1])[0]
    return {
      sentence: {
        all: progress.length,
        answered: progress.filter((p) => p.answered).length,
        current
      },
      page: {
        all: pageProgress.length,
        current: state.currentPage
      },
      detail: {
        selected: {
          rowIndex: state.selectedRow,
          beginIndex: state.selectedBegin
        },
        pages: pageProgress,
        reader: {
          all: progress.filter((p) => p.reader).length,
          answered: progress.filter((p) => p.reader).filter((p) => p.answered)
            .length
        },
        test: {
          all: progress.filter((p) => !p.reader).length,
          answered: progress.filter((p) => !p.reader).filter((p) => p.answered)
            .length
        }
      }
    }
  }

  evaluated(answers) {
    const state = this.copyState()
    state.answers.push({
      time: Date.now(),
      rowIndex: state.selectedRow,
      beginIndex: state.selectedBegin,
      endIndex: state.selectedEnd,
      answers
    })
    this.updateCompleted(state)

    this.setState(state, () => {
      this.notifyPageStateChanges()
      this.scrollView()
      if (!this.props.onEvaluated) {
        return
      }
      this.props.onEvaluated(this.getContext(this.state))
    })
  }

  copyState() {
    const state = Object.assign({}, this.state)
    state.answers = state.answers.map((a) => Object.assign({}, a))
    state.activities = state.activities.map((a) => Object.assign({}, a))
    return state
  }

  nextPage(nextIndex) {
    const content = new ClozeContent(this.props.data)
    const pages = content.getPages()
    const index = nextIndex === undefined ? this.state.current + 1 : nextIndex
    if (this.props.data.rows.length <= index) {
      const { pageId } = content.getPageId(
        this.props.data.rows[this.props.data.rows.length - 1],
        this.props.data.rows.length - 1
      )
      return {
        index: this.props.data.rows.length,
        pageId,
        pageIndex: pages.length - 1,
        pages
      }
    }
    const { pageId } = content.getPageId(this.props.data.rows[index], index)
    const rowIndices = this.props.data.rows
      .map((row, i) => [row, i])
      .filter((rowd) => content.getPageId(rowd[0], rowd[1]).pageId === pageId)
      .map((rowd) => rowd[1])
    return {
      index: rowIndices[rowIndices.length - 1],
      pageId,
      pageIndex: pages
        .map((p, index) => [p, index])
        .filter((pd) => pd[0].pageId === pageId)
        .map((pd) => pd[1])[0],
      pages
    }
  }

  imageClicked(event) {
    this.setState({
      imageFocused: !this.state.imageFocused
    })
  }

  resume() {
    const resumeCallback = () =>
      this.setState({
        imageFocused: false,
        reader: this.isAnswered(
          this.state,
          this.state.selectedRow,
          this.state.selectedBegin
        )
          ? true
          : this.state.reader
      })
    resumeCallback()
  }

  imageLoad() {
    this.setState({
      imageLoading: false
    })
  }

  isPageAlreadyAnswered(state, pageNumber) {
    return state.pages[pageNumber].bounds.every((b) =>
      this.isAnswered(state, b.rowIndex, b.beginIndex)
    )
  }

  findPageByRowIndex(allPages, rowIndex) {
    const pages = allPages
      .map((page, index) => [page, index])
      .filter((page) => page[0].bounds.some((b) => b.rowIndex === rowIndex))
    if (pages.length === 0) {
      throw new Error(`No pages for ${rowIndex}`)
    }
    return pages[0][1]
  }

  showStatement(rowIndex, beginIndex, callback) {
    if (!this.state.pages || !this.state.pages[this.state.currentPage]) {
      return
    }
    let target = this.state.pages[this.state.currentPage].bounds
      .map((b, index) => [index, b])
      .filter(
        (b) => b[1].rowIndex === rowIndex && b[1].beginIndex === beginIndex
      )

    const state = this.copyState()
    if (target.length === 0) {
      // changes a page?
      state.currentPage = this.findPageByRowIndex(this.state.pages, rowIndex)
      this.updateImage(state)
      console.log('Page changes', state.currentPage)
      target = this.state.pages[state.currentPage].bounds
        .map((b, index) => [index, b])
        .filter(
          (b) => b[1].rowIndex === rowIndex && b[1].beginIndex === beginIndex
        )
      this.updateCompleted(state)
    }
    if (target.length > 0) {
      state.selectedRow = target[0][1].rowIndex
      state.selectedBegin = target[0][1].beginIndex
      state.selectedEnd = target[0][1].endIndex
      state.reader = this.isAnswered(
        state,
        state.selectedRow,
        state.selectedBegin
      )
      if (
        this.props.data.rows[state.selectedRow]
          .slice(state.selectedBegin, state.selectedEnd)
          .every((cell) => cell.split('|').length <= 1)
      ) {
        state.reader = true
        if (
          !this.isAnswered(
            state,
            state.selectedRow,
            state.selectedBegin,
            state.selectedEnd
          )
        ) {
          state.answers.push({
            time: Date.now(),
            rowIndex: state.selectedRow,
            beginIndex: state.selectedBegin,
            endIndex: state.selectedEnd,
            answers: []
          })
          this.updateCompleted(state)
        }
      } else if (!state.reader) {
        const skippable = generateAnswer(
          this.props.minRate,
          state,
          state.selectedRow,
          state.selectedBegin
        )
        if (skippable) {
          state.reader = true
          state.answers.push(skippable)
          this.updateCompleted(state)
        }
      }
    } else {
      state.selectedRow = null
      state.selectedBegin = null
      state.selectedEnd = null
      state.reader = false
    }
    const nextTarget = this.state.pages[state.currentPage].bounds.filter(
      (b) =>
        b.rowIndex > state.selectedRow ||
        (b.rowIndex === state.selectedRow && b.beginIndex > state.selectedBegin)
    )
    const previousTarget = this.state.pages[state.currentPage].bounds.filter(
      (b) =>
        b.rowIndex < state.selectedRow ||
        (b.rowIndex === state.selectedRow && b.beginIndex < state.selectedBegin)
    )
    state.hasNext = nextTarget.length > 0
    state.hasPrevious = previousTarget.length > 0
    state.hasPreviousPage = state.currentPage > 0
    state.hasNextPage = state.currentPage + 1 < this.state.pages.length
    state.lastActivities = null
    this.setState(state, () => {
      this.notifyPageStateChanges()
      if (!callback) {
        return
      }
      callback()
    })
    if (state.selectedRow !== null && this.props.onStatementOpen) {
      this.props.onStatementOpen(
        this.props.data.rows[state.selectedRow].slice(
          state.selectedBegin,
          state.selectedEnd
        ),
        this.getContext(state),
        this.getProgress(state)
      )
    }
    this.scrollView()
  }

  notifyPageStateChanges() {
    if (!this.props.onPageStateChange) {
      return
    }
    const completed = this.isAnswered(
      this.state,
      this.state.selectedRow,
      this.state.selectedBegin
    )
    const enableControl = this.state.reader || completed
    const hasNextPage =
      enableControl && this.state.pageCompleted && this.state.hasNextPage
    const hasPreviousPage = enableControl && this.state.hasPreviousPage
    this.props.onPageStateChange({
      hasNextPage,
      hasPreviousPage
    })
  }

  checkAndNotifyActivitiesAdded(prevState) {
    const { onActivitiesAdded } = this.props;
    if (!onActivitiesAdded) {
      return;
    }
    if (!prevState) {
      return;
    }
    const currentActivitiesCount = (this.state.activities || []).length + (this.state.lastActivities || []).length;
    const prevActivitiesCount = (prevState.activities || []).length + (prevState.lastActivities || []).length;
    if (prevActivitiesCount === currentActivitiesCount) {
      return;
    }
    onActivitiesAdded((this.state.activities || [])
      .map((a) => a.activities)
      .reduce((x, y) => x.concat(y), [])
      .concat(this.state.lastActivities || []));
  }

  scrollView(delay) {
    setTimeout(() => {
      if (!this.currentSentenceRef.current) {
        return
      }
      this.currentSentenceRef.current.scrollIntoView(false)
    }, delay || 200)
  }

  requestAdditionalLinks(words, callback) {
    if (!callback) {
      return
    }
    const { onAdditionalLinksRequest } = this.props
    if (!onAdditionalLinksRequest) {
      // eslint-disable-next-line standard/no-callback-literal
      callback([])
      return
    }
    const state = this.state
    const location = {
      rowIndex: state.selectedRow,
      beginIndex: state.selectedBegin,
      endIndex: state.selectedEnd
    }
    onAdditionalLinksRequest(location, words, callback)
  }

  resolveTranslateRequest(words) {
    if (this.props.translateRequest) {
      return this.props.translateRequest(axios, words)
    }
    return axios.post(
      `${this.props.baseURL || ''}/translate/${this.props.context}`,
      {
        words: words.join(' ')
      }
    )
  }

  resolveWordRequest(word) {
    if (this.props.wordRequest) {
      return this.props.wordRequest(axios, word.toLowerCase())
    }
    return axios.get(
      `${this.props.baseURL || ''}/word/${
        this.props.context
      }/${word.toLowerCase()}`
    )
  }

  resolveJaWordRequest(word) {
    if (this.props.jaWordRequest) {
      return this.props.jaWordRequest(axios, word.toLowerCase())
    }
    return axios.get(
      `${this.props.baseURL || ''}/jaword/${
        this.props.context
      }/${word.toLowerCase()}`
    )
  }

  resolveImageURL(image) {
    if (image === null) {
      return null
    }
    if (this.props.imageURL) {
      return this.props.imageURL(image)
    }
    if (!this.props.context) {
      return null
    }
    return `${this.props.baseURL || ''}/image/${this.props.context}/${image}`
  }

  renderWords(words, answered) {
    const elems = []
    words.forEach((word) => {
      if (elems.length > 0 && word.match(/[a-zA-Z0-9]+.*/)) {
        elems.push(<span> </span>)
      }
      if (!answered && word.includes('|')) {
        elems.push(
          <span className={styles.PreviewBlank}>
            {'\u00A0'.repeat(word.split('|')[0].length * 2)}
          </span>
        )
        return
      }
      elems.push(<span>{word.split('|')[0]}</span>)
    })
    return elems
  }

  googleSearch(word, callback) {
    if (!this.props.onGoogleSearch) {
      callback()
      return
    }
    this.props.onGoogleSearch(word, callback)
  }

  enDictRequest(word) {
    this.scrollView()
    if (!this.props.onEnDictRequest) {
      return
    }
    this.props.onEnDictRequest(word)
  }

  jaDictRequest(word) {
    this.scrollView()
    if (!this.props.onJaDictRequest) {
      return
    }
    this.props.onJaDictRequest(word)
  }

  jpTranslateRequest(words) {
    this.scrollView()
    if (!this.props.onJpTranslateRequest) {
      return
    }
    this.props.onJpTranslateRequest(words)
  }

  wordsOpen(words) {
    this.scrollView(10)
    if (!this.props.onWordsOpen) {
      return
    }
    this.props.onWordsOpen(words)
  }

  async evaluate(row, choice) {
    if (this.props.evaluate) {
      return await this.props.evaluate(row, choice)
    }
    const r = {}
    Object.entries(choice).forEach((c) => {
      r[c[0]] = {
        judge: c[1].answer === c[1].correct ? 'correct' : 'incorrect',
        semantic_score: c[1].answer === c[1].correct ? 1.0 : 0.0,
        grammar_score: c[1].answer === c[1].correct ? 1.0 : 0.0
      }
    })
    return r
  }

  isReadyToStart(props, state) {
    const props_ = props || this.props
    const state_ = state || this.state
    if (this.getFirstImage() && state_.imagePreloading) {
      return false
    }
    return props_.ready === undefined ? true : props_.ready
  }

  getFirstImage() {
    const { pages } = this.nextPage()
    let pageNum = 0
    if (this.props.selected) {
      pageNum = this.findPageByRowIndex(pages, this.props.selected.rowIndex)
    }
    return pages[pageNum].image ? pages[pageNum].pageId : null
  }

  toLeftPage() {
    if (this.props.isRightToLeft) {
      this.toNextPage()
    } else {
      this.toPreviousPage()
    }
  }

  toRightPage() {
    if (this.props.isRightToLeft) {
      this.toPreviousPage()
    } else {
      this.toNextPage()
    }
  }

  onKeyDown(event) {
    if (event.code === 'ArrowLeft') {
      this.toLeftPage()
    } else if (event.code === 'ArrowRight') {
      this.toRightPage()
    }
  }

  render() {
    const control =
      this.state.selectedRow !== null &&
      this.props.data.rows[this.state.selectedRow] ? (
        this.state.reader ? (
          <Reader
            rowKey={`${this.state.selectedRow},${this.state.selectedBegin}`}
            row={this.props.data.rows[this.state.selectedRow].slice(
              this.state.selectedBegin,
              this.state.selectedEnd
            )}
            chunks={(this.props.data.chunks || [])[this.state.selectedRow]}
            rowOffset={this.state.selectedBegin}
            disableWordClick={this.props.disableWordClick}
            hint={this.props.hint}
            onHintPerform={this.props.onHintPerform}
            hasNext={this.state.hasNext}
            hasPrevious={this.state.hasPrevious}
            completed={this.state.completed}
            hasNextPage={this.state.pageCompleted && this.state.hasNextPage}
            hasPreviousPage={this.state.hasPreviousPage}
            onAdditionalLinksRequest={(words, callback) =>
              this.requestAdditionalLinks(words, callback)
            }
            onNext={(activities) => this.nextClicked(true, activities)}
            onPrevious={(activities) => this.nextClicked(false, activities)}
            onNextPage={(activities) => this.nextPageClicked(true, activities)}
            onPreviousPage={(activities) =>
              this.nextPageClicked(false, activities)
            }
            onExit={(activities) => this.finish(activities)}
            onEnDictRequest={(w) => this.enDictRequest(w)}
            onJaDictRequest={(w) => this.jaDictRequest(w)}
            onJpTranslateRequest={(w) => this.jpTranslateRequest(w)}
            onGoogleSearch={(word, callback) =>
              this.googleSearch(word, callback)
            }
            onWordsOpen={(words) => this.wordsOpen(words)}
            onActivitiesRecorded={(activities) =>
              this.setState({ lastActivities: activities })
            }
            wordRequest={(word) => this.resolveWordRequest(word)}
            jaWordRequest={(word) => this.resolveJaWordRequest(word)}
            translateRequest={(words) => this.resolveTranslateRequest(words)}
          />
        ) : (
          <Test
            rowKey={`${this.state.selectedRow},${this.state.selectedBegin}`}
            row={this.props.data.rows[this.state.selectedRow].slice(
              this.state.selectedBegin,
              this.state.selectedEnd
            )}
            chunks={(this.props.data.chunks || [])[this.state.selectedRow]}
            rowOffset={this.state.selectedBegin}
            disableWordClick={this.props.disableWordClick}
            hint={this.props.hint}
            onHintPerform={this.props.onHintPerform}
            hasNext={this.state.hasNext}
            hasPrevious={this.state.hasPrevious}
            completed={this.state.completed}
            hasNextPage={this.state.pageCompleted && this.state.hasNextPage}
            hasPreviousPage={this.state.hasPreviousPage}
            evaluate={(row, choice) => this.evaluate(row, choice)}
            onStart={() => this.scrollView()}
            onAdditionalLinksRequest={(words, callback) =>
              this.requestAdditionalLinks(words, callback)
            }
            onNext={(activities) => this.nextClicked(true, activities)}
            onPrevious={(activities) => this.nextClicked(false, activities)}
            onNextPage={(activities) => this.nextPageClicked(true, activities)}
            onPreviousPage={(activities) =>
              this.nextPageClicked(false, activities)
            }
            onExit={(activities) => this.finish(activities)}
            onEvaluated={(answers) => this.evaluated(answers)}
            onFocusChange={() => this.scrollView()}
            onEnDictRequest={(w) => this.enDictRequest(w)}
            onJaDictRequest={(w) => this.jaDictRequest(w)}
            onJpTranslateRequest={(w) => this.jpTranslateRequest(w)}
            onGoogleSearch={(word, callback) =>
              this.googleSearch(word, callback)
            }
            onWordsOpen={(words) => this.wordsOpen(words)}
            onActivitiesRecorded={(activities) =>
              this.setState({ lastActivities: activities })
            }
            onAnswersAdded={this.props.onAnswersAdded}
            wordRequest={(word) => this.resolveWordRequest(word)}
            jaWordRequest={(word) => this.resolveJaWordRequest(word)}
            translateRequest={(words) => this.resolveTranslateRequest(words)}
            questionMessage={this.props.questionMessage}
            resultMessage={this.props.resultMessage}
          />
        )
      ) : (
        <div className={styles.SentenceHelp}>
          文をタップするとここに大きく表示されます
        </div>
      )

    const textContent = (
      <div className={styles.TextBase}>
        {(
          this.state.pages[this.state.currentPage] || { bounds: [] }
        ).bounds.map((bound, index) =>
          bound.rowIndex === this.state.selectedRow &&
          bound.beginIndex === this.state.selectedBegin ? (
            <div className={styles.TargetText} ref={this.currentSentenceRef}>
              {control}
            </div>
          ) : (
            <span
              key={index}
              className={this.props.otherTextClass || styles.OtherText}
            >
              <span className={styles.ParagraphBegin} />
              {bound.beginIndex < bound.row.length &&
                bound.row[bound.beginIndex].includes('\n') && (
                  <span>
                    <br />
                    <span className={styles.ParagraphBegin} />
                  </span>
                )}
              {this.renderWords(
                bound.row.slice(bound.beginIndex, bound.endIndex),
                this.isAnswered(this.state, bound.rowIndex, bound.beginIndex)
              )}
              {(
                (bound.endIndex < bound.row.length &&
                  bound.row[bound.endIndex]) ||
                ''
              ).includes('\n') && <br />}
              {bound.endIndex >= bound.row.length && <br />}
            </span>
          )
        )}
      </div>
    )

    const content =
      this.state.image == null ? (
        textContent
      ) : (
        <div className={styles.ImageBase}>
          {this.state.imageLoading && (
            <div className={styles.ImageLoadingOverlay}>
              Loading...
              <ClipLoader size='14' color='white' />
            </div>
          )}
          <ClozeImage
            canvasClassName={
              this.state.canvasHint === 2
                ? `${styles.Image} ${styles.CanvasWithTooltip}`
                : styles.Image
            }
            imageId={this.state.image}
            ref={this.canvasRef}
            imageRef={this.imageRef}
            pages={this.state.pages}
            currentPage={this.state.currentPage}
            onAnswersCheck={(beginIndex, endIndex) =>
              this.isAnswered(this.state, beginIndex, endIndex)
            }
            imageFocused={this.state.imageFocused}
            selectedRow={this.state.selectedRow}
            selectedBegin={this.state.selectedBegin}
            onImageClick={(e) => this.imageClicked(e)}
          />
          <Overlay
            target={this.canvasRef.current}
            show={this.state.canvasHint === 2}
            rootClose
            onHide={() => this.hideHint('canvas')}
            placement='auto'
          >
            {(props) => (
              <Tooltip id='canvas-tooltip' {...props}>
                画像をタップして全画面表示
              </Tooltip>
            )}
          </Overlay>
          {this.state.image && (
            <img
              ref={this.imageRef}
              className={styles.CachedImage}
              onLoad={(e) => this.imageLoad(e)}
              src={this.resolveImageURL(this.state.image)}
            />
          )}
          {this.state.nextImage && (
            <img
              className={styles.CachedImage}
              src={this.resolveImageURL(this.state.nextImage)}
            />
          )}
        </div>
      )

    const leftAndRightOverlayButtons = this.state.image ? (
      <React.Fragment>
        <button
          className={styles.OverlayLeftButton}
          tabIndex={-1}
          onClick={() => this.toLeftPage()}
        >
          <FontAwesomeIcon icon={faAngleLeft} size='2x' />
        </button>
        <button
          className={styles.OverlayRightButton}
          tabIndex={-1}
          onClick={() => this.toRightPage()}
        >
          <FontAwesomeIcon icon={faAngleRight} size='2x' />
        </button>
      </React.Fragment>
    ) : null

    return (
      <div className={styles.ImageReader}>
        {this.state.current < 0 ? (
          <div className={styles.Greeting}>
            <Button
              data-test-image-reader-start
              disabled={!this.isReadyToStart()}
              onClick={() => this.start()}
              variant={this.state.imagePreloadError ? 'danger' : 'primary'}
            >
              {!this.state.imagePreloadError &&
              this.getFirstImage() &&
              this.state.imagePreloading ? (
                <span>
                  <ClipLoader size='16' color='white' />
                  <span>画像を読み込み中です...</span>
                </span>
              ) : this.state.imagePreloadError ? (
                'エラー: 画像を読み込めませんでした'
              ) : (
                'はじめる'
              )}
            </Button>
            {this.resolveImageURL(this.getFirstImage()) && (
              <img
                className={styles.CachedImage}
                onLoad={() => this.setState({ imagePreloading: false })}
                onError={() => this.setState({ imagePreloadError: true })}
                src={this.resolveImageURL(this.getFirstImage())}
              />
            )}
          </div>
        ) : this.state.finished ? (
          <div className={styles.Finished}>終わりです！</div>
        ) : (
          <div>
            {leftAndRightOverlayButtons}
            {this.state.image && (
              <NavContainer>
                {!this.state.imageFocused && (
                  <div
                    className={`${styles.ImageControl} ${
                      this.props.imageControlClass || ''
                    }`}
                  >
                    {this.state.imageLoading ? (
                      <div>
                        <ClipLoader />
                        <div>画像を読み込み中です...</div>
                      </div>
                    ) : (
                      control
                    )}
                  </div>
                )}
                {this.state.imageFocused && (
                  <div
                    className={`${styles.Resume} ${
                      this.props.imageControlClass || ''
                    }`}
                  >
                    <Button
                      ref={this.restoreRef}
                      data-test-bidirectional-restore-test
                      onClick={() => this.resume()}
                      variant='primary'
                      size='sm'
                    >
                      続きを再開
                    </Button>
                    <Overlay
                      target={this.restoreRef.current}
                      show={this.state.restoreHint === 2}
                      rootClose
                      onHide={() => this.hideHint('restore')}
                      placement='top'
                    >
                      {(props) => (
                        <Tooltip id='restore-tooltip' {...props}>
                          タップして元画面に戻る
                        </Tooltip>
                      )}
                    </Overlay>
                  </div>
                )}
              </NavContainer>
            )}
            {content}
          </div>
        )}
      </div>
    )
  }
}

export default BidirectionalTest
